const SURVEY_LINE = /^SURVEY\b/m

/**
 * Puts a `SURVEY <projectName>` line in front of text that is about to be
 * inserted, when the editor has no SURVEY line yet (an empty questionnaire).
 * Otherwise the text is returned unchanged.
 *
 * @param editorText - The editor's current plain text
 * @param insertText - The text about to be inserted
 * @param projectName - The project's name, used as the survey name
 */
export const withSurveyFrame = (
  editorText: string,
  insertText: string,
  projectName: string
): string =>
  SURVEY_LINE.test(editorText)
    ? insertText
    : `SURVEY ${projectName}\n\n` + insertText
